import ValeFleetInfo from './vale-fleet-info.js'
import { react2angular } from 'react2angular'
import Car from './CarInfo'
import Alarm from './ShowAlarm'
import Fault from './ShowFault'
import Train from './TrainInfo'
import LocomotiveCar from './Locomotive'
import ValeView from './vale-fleet-info'

// TODO move to correct module
angular.module('webtip.module')
  .component('fleetGridletContentVale', react2angular(ValeView,[],['fleetService', 'CommonService', '$state']))

export const ShowAlarm = Alarm;
export const ShowFault = Fault;
export const TrainInfo = Train;
export const CarInfo = Car;
export const Locomotive = LocomotiveCar;